import { supabase } from '../lib/supabase';

// Category service for business directory
export const categoryService = {
  // Get all active categories
  async getCategories() {
    try {
      const { data, error } = await supabase
        ?.from('categories')
        ?.select(`
          id,
          name,
          slug,
          description,
          icon_url,
          parent_id,
          is_active,
          created_at
        `)
        ?.eq('is_active', true)
        ?.order('name', { ascending: true });

      if (error) {
        return { data: [], error: error?.message };
      }

      return { data: data || [], error: null };
    } catch (error) {
      const errorMessage = error?.message?.includes('Failed to fetch')
        ? 'Cannot connect to database. Your Supabase project may be paused or deleted. Please visit your Supabase dashboard to check project status.' :'Failed to load categories. Please try again.';
      
      return { data: [], error: errorMessage };
    }
  },

  // Get category by ID
  async getCategoryById(categoryId) {
    try {
      const { data, error } = await supabase
        ?.from('categories')
        ?.select(`
          id,
          name,
          slug,
          description,
          icon_url,
          parent_id,
          is_active,
          created_at
        `)
        ?.eq('id', categoryId)
        ?.eq('is_active', true)
        ?.single();

      if (error) {
        return { data: null, error: error?.message };
      }

      return { data, error: null };
    } catch (error) {
      return { data: null, error: 'Failed to load category details.' };
    }
  },

  // Get category by slug
  async getCategoryBySlug(slug) {
    try {
      const { data, error } = await supabase
        ?.from('categories')
        ?.select(`
          id,
          name,
          slug,
          description,
          icon_url,
          parent_id,
          is_active,
          created_at
        `)
        ?.eq('slug', slug)
        ?.eq('is_active', true)
        ?.single();

      if (error) {
        return { data: null, error: error?.message };
      }

      return { data, error: null };
    } catch (error) {
      return { data: null, error: 'Failed to load category details.' };
    }
  },

  // Get subcategories by parent category ID
  async getSubcategories(parentId) {
    try {
      const { data, error } = await supabase
        ?.from('categories')
        ?.select(`
          id,
          name,
          slug,
          description,
          icon_url,
          parent_id,
          is_active,
          created_at
        `)
        ?.eq('parent_id', parentId)
        ?.eq('is_active', true)
        ?.order('name', { ascending: true });

      if (error) {
        return { data: [], error: error?.message };
      }

      return { data: data || [], error: null };
    } catch (error) {
      return { data: [], error: 'Failed to load subcategories.' };
    }
  },

  // Get top-level categories (no parent)
  async getTopLevelCategories() {
    try {
      const { data, error } = await supabase
        ?.from('categories')
        ?.select(`
          id,
          name,
          slug,
          description,
          icon_url,
          parent_id,
          is_active,
          created_at
        `)
        ?.is('parent_id', null)
        ?.eq('is_active', true)
        ?.order('name', { ascending: true });

      if (error) {
        return { data: [], error: error?.message };
      }

      return { data: data || [], error: null };
    } catch (error) {
      return { data: [], error: 'Failed to load categories.' };
    }
  },

  // Get categories with business counts
  async getCategoriesWithCounts() {
    try {
      const { data, error } = await supabase
        ?.from('categories')
        ?.select(`
          id,
          name,
          slug,
          description,
          icon_url,
          parent_id,
          is_active,
          created_at,
          businesses!inner(count)
        `)
        ?.eq('is_active', true)
        ?.eq('businesses.status', 'active')
        ?.order('name', { ascending: true });

      if (error) {
        return { data: [], error: error?.message };
      }

      return { data: data || [], error: null };
    } catch (error) {
      return { data: [], error: 'Failed to load categories with counts.' };
    }
  }
};

export default categoryService;